var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWnLogoHeartGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.82 169.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffc629;}.cls-2{fill:#414042;}.cls-3{fill:#ffc629;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M360.4,173.36c-38.58-5.72-51.12,16.53-52,18.13-.85-1.6-13.39-23.85-52-18.13-43,6.39-54.46,62.77-18.7,107.55,38.44,48.15,68.66,60.34,70.61,61.09v0l.05,0,.05,0v0c1.95-.75,32.16-12.94,70.61-61.09,35.75-44.78,24.29-101.16-18.7-107.55",
    transform: "translate(-216.53 -172.42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M308.44,292.06c-11.74,0-32.73-3.35-42.14-13.79-6.16-6.83-11.24-17.32,11.78-11.54,0,0,.19-4.79.74-5.14-.46-15.3-1.48-31.95-4.2-47.72-.15-.88.44-1.41,2.48-1.62a284.65,284.65,0,0,1,62.67,0c2.05.21,2.64.74,2.49,1.62-2.72,15.77-3.74,32.42-4.2,47.72.54.35.74,5.14.74,5.14,23-5.78,17.94,4.71,11.78,11.54-9.41,10.44-30.4,13.79-42.14,13.79",
    transform: "translate(-216.53 -172.42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M278.77,261.61a127.2,127.2,0,0,0,59.35,0s.68,0,.68,1.76V272s-8.3,5-30.39,5S278,271.92,278,271.92v-8.84s0-1.36.73-1.47",
    transform: "translate(-216.53 -172.42)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWnLogoHeartGold);
export default __webpack_public_path__ + "static/media/wn-logo-heart-gold.fcc21d28f6c6482af8176ca811ce9b8f.svg";
export { ForwardRef as ReactComponent };